import React from 'react';
import PropTypes from 'prop-types';

export const SlideContainer = ({ style = {}, children }) => (
    <div
        className="h-auto min-h-full w-full bg-gray-400 pt-24"
        style={style}
        data-testid="slide-container"
    >
        <div className="w-4/5 mx-auto">
            {children}

            <footer className="mt-4">
                <div className="presentation-logo">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/desco-logo-for-presentation.png`}
                        alt=""
                    />
                </div>
            </footer>
        </div>
    </div>
);
SlideContainer.propTypes = {
    style: PropTypes.object,
    children: PropTypes.any,
};

export const SlideContainerWithHeader = ({ header, style = {}, children }) => (
    <div
        className="h-auto min-h-full w-full bg-gray-300 pt-24 overflow-auto"
        style={style}
        data-testid="slide-container"
    >
        <div className="w-4/5 mx-auto">
            <div className="pb-2 md:pb-4" style={{ color: '#668aae' }}>
                <div className="block text-xl md:text-3xl font-bold uppercase float-left w-4/5">
                    {' '}
                    {header}{' '}
                </div>
                <div className="presentation-logo float-right w-1/5">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/desco-logo-for-presentation.png`}
                        alt=""
                    />
                </div>
                <div className="clearfix" />
            </div>
            <div className={'block'}>
                <br />
            </div>
            {children}
        </div>
    </div>
);
SlideContainerWithHeader.propTypes = {
    header: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.any,
};

export const SlideList = ({ list, style = {} }) => (
    <ul className="list-disc pl-6 pb-4" style={style}>
        {list.map((item, index) => (
            <li key={index} className="pl-6 md:leading-relaxed">
                {' '}
                {item}{' '}
            </li>
        ))}
    </ul>
);

SlideList.propTypes = {
    list: PropTypes.array,
    style: PropTypes.object,
};
